import { cn } from '@lemoment/lib/utils';

/** Lemoment wordmark — "Lem●ment" with the LemonCloud orange counter dot. */
export const Wordmark = ({ className }: { className?: string }) => (
  <span className={cn('font-display inline-flex items-baseline', className)}>
    <span className="font-semibold tracking-tight">Lem</span>
    <span
      className="mx-[0.06em] inline-block h-[0.62em] w-[0.62em] translate-y-[0.02em] rounded-full bg-lemon ring-1 ring-lemon-ink/30"
      aria-hidden
    />
    <span className="font-semibold tracking-tight">ment</span>
  </span>
);
